import { Navigate, useLocation } from 'react-router-dom'

import Roles from '../../enums/Roles'
import useAuth from '../../hooks/useAuth'
import PropTypes from 'prop-types'
import { AuthContext } from '../../contexts/AuthContext'
import { useContext } from 'react'
import useProfileCompleted from '../../hooks/useProfileCompleted'

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { isLoggedIn, getUserRole, getEmailVerified } = useAuth()
    const location = useLocation()
    const { token } = useContext(AuthContext)

    if (!isLoggedIn()) {
        return <Navigate to="/login" replace={true} />
    }

    const profileCompleted = useProfileCompleted(token)

    const emailVerifed = getEmailVerified()
    if (!emailVerifed && location.pathname !== '/profile') {
        return <Navigate to="/profile" replace={true} />
    }

    if (!profileCompleted && location.pathname !== '/profile') {
        return <Navigate to="/profile" replace={true} />
    }

    const userRole = getUserRole()

    if (!allowedRoles.includes(userRole)) {
        return userRole === Roles.admin ? (
            <Navigate to="/admin" replace={true} />
        ) : (
            <Navigate to="/" replace={true} />
        )
    }

    return children
}

ProtectedRoute.propTypes = {
    children: PropTypes.object,
    allowedRoles: PropTypes.arrayOf(PropTypes.string),
}

export default ProtectedRoute
